module.exports = __webpack_public_path__ + "img/qrcode.7815316a.png";